import { ArrowRight } from 'components/Icons'
import CountDown from 'components/CountDown/RoundedCountDown'
import React from 'react'
import {
  SectionHeading,
  SectionHeadingH1,
  SectionLink,
  SectionWithHeading,
  HeadingContainer,
} from './SectionBlock.style'
import { Link } from 'react-router-dom'
import { BadgeBestPrice } from 'style/CategoryList/CategoryList.style'

const BannerSection = ({ banners }) => {
  if (!banners?.length) return null

  return (
    <div>
      <div className="banners flex items-center justify-center gap-4 mb-4">
        {banners.map((banner, index) => (
          <Link key={index} to={banner.url || '#'} className="banner-item">
            <img
              src={banner.image}
              alt={banner.alt || 'Banner'}
              className="rounded-2xl"
            />
          </Link>
        ))}
      </div>
    </div>
  )
}

const SectionHeader = ({
  title,
  id,
  countdown,
  link,
  linkText,
  titleComponent,
}) => {
  const TComponent = titleComponent === 'h1' ? SectionHeadingH1 : SectionHeading

  if (!title && !linkText) return null

  return (
    <TComponent>
      <HeadingContainer>
        {id ? <Link to={`/products/${id}`}>{title}</Link> : title}

        {id === 121 && <BadgeBestPrice>BEST PRICE</BadgeBestPrice>}

        {countdown && (
          <div>
            <CountDown
              type="rounded"
              date={countdown}
              className="desktop-countdown"
            />
          </div>
        )}
      </HeadingContainer>

      {link && linkText && (
        <SectionLink to={link || '#'}>
          {linkText}
          <ArrowRight color="black2" />
        </SectionLink>
      )}
    </TComponent>
  )
}

const SectionBlock = props => {
  const {
    title,
    countdown,
    linkText,
    link,
    titleComponent,
    id,
    children,
    icon,
    banners,
    ...rest
  } = props

  return (
    <SectionWithHeading {...rest}>
      <SectionHeader
        title={title}
        id={id}
        countdown={countdown}
        link={link}
        linkText={linkText}
        titleComponent={titleComponent}
      />

      <BannerSection banners={banners?.before} />

      {children}

      <BannerSection banners={banners?.after} />
    </SectionWithHeading>
  )
}

export default SectionBlock
